import React from "react";

export default function Google_Content() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Google_Content</h2>
      <p>Route: /icons/google/content</p>
    </div>
  );
}
